import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"

// This controller is used to stop sequence for multiple selected rows in the engagement table
export default class extends Controller {
  static get values() {
    return {
      outreachEnabled: Boolean,
      selectedEmails: { type: Array, default: [] },
      selectedCampaignIds: { type: Array, default: [] },
    }
  }

  // This action submits a temporary form to stop sequence for emails in campaigns
  submit() {
    if (!this.outreachEnabledValue) {
      App.displayFlash("danger", i18n.t("js.back.lead_actions.connect_google_account_html"))
      return
    }

    if (this.selectedEmailsValue.length === 0 || this.selectedCampaignIdsValue.length === 0) {
      App.displayFlash("danger", i18n.t("js.back.engagement.select_messages_to_stop_sequence"))
      return
    }

    TempFormHelper.create("/campaigns/sequence", "delete", (form) => {
      this.selectedCampaignIdsValue.forEach(campaignId => { TempFormHelper.addHiddenInput(form, "campaign_ids[]", campaignId) })
      this.selectedEmailsValue.forEach(email => { TempFormHelper.addHiddenInput(form, "emails[]", email) })
    }).submit()
  }

  updateSelection(event) {
    if (event.detail.dataSets) {
      this.selectedEmailsValue = event.detail.dataSets.map(dataSet => dataSet.email)
      this.selectedCampaignIdsValue = event.detail.dataSets.map(dataSet => dataSet.campaignId)
    } else {
      this.selectedCampaignIdsValue = []
      this.selectedEmailsValue = []
    }
  }
}
